import { render, staticRenderFns } from "./EvoBoVarSelector.vue?vue&type=template&id=dbbfa21c&scoped=true&"
import script from "./EvoBoVarSelector.vue?vue&type=script&lang=js&"
export * from "./EvoBoVarSelector.vue?vue&type=script&lang=js&"
import style0 from "./EvoBoVarSelector.vue?vue&type=style&index=0&id=dbbfa21c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbfa21c",
  null
  
)

export default component.exports